import { t } from 'i18next';
import { FC, useEffect, useState } from 'react';
import { Trans } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router';
import { optionalAsset } from '../../../services/assetResolverService';
import { TRequiredRegistrationEvent } from '../../../../types/eventTypes';
import { Image } from '../../../components/image/Image';
import Modal from '../../../components/modal/modal';
import { resolveRoutePath } from '../../../bundles/routes';
import { commonRoutes } from '../../../../gameConfig/commonRoutes';
import { Link } from '../../../components/link';

interface IUserRequiredRegistrationToEventModalProps {
  requiredRegistrationEvent: TRequiredRegistrationEvent;
  onMute: (id: number, isLong?: boolean) => void;
}
export const UserRequiredRegistrationToEventModal: FC<IUserRequiredRegistrationToEventModalProps> = ({
  requiredRegistrationEvent,
  onMute
}) => {
  const { event, team } = requiredRegistrationEvent;
  const navigate = useNavigate();
  const location = useLocation();
  const [isModalOpen, setIsModalOpen] = useState(true);

  const eventPath = resolveRoutePath(commonRoutes.EventRegister, { slug: event.slug });

  useEffect(() => {
    setIsModalOpen(true);
  }, [requiredRegistrationEvent]);

  const handleClose = () => {
    onMute(event.id, true);
    setIsModalOpen(false);
  };

  const handleGoToRegistration = () => {
    navigate(eventPath);
    handleClose();
  };

  const isOpen = eventPath !== location.pathname && isModalOpen;

  return (
    <Modal
      isOpen={isOpen}
      className="background-common--important rio-modal--centered "
      classModalContent="raider-modal__content"
      shouldCloseOnOverlayClick={true}
      onRequestClose={handleClose}
    >
      <div className="raider-modal__header">
        <div className="slds-text-heading--medium text-bold slds-text-align--center slds-grid slds-grid--vertical-align-center">
          <i className="text-warn fa fa-exclamation-triangle slds-m-right--x-small" />
          {t('registration-pages:modals.required-event-registration.title')}
        </div>
        <button className="raider-modal__close" onClick={handleClose}>
          <i className="fa fa-close" />
        </button>
      </div>
      {(event.image_url || event.header_image) && <Image src={[event.header_image, optionalAsset(event.image_url)]} />}
      <div className="rio-modal__body">
        <p className="slds-text-heading--medium slds-m-bottom--small slds-text-align--center text-bold">
          {event.title}
        </p>
        <p className="slds-text-heading--small slds-m-bottom--small slds-text-align--center">
          <Trans
            i18nKey="registration-pages:modals.required-event-registration.description"
            values={{ teamName: team.name }}
          >
            <Link to={team.path!} className="text-bold" />
          </Trans>
        </p>
        <div className="slds-text-align--center slds-m-top--large">
          <button
            className="slds-button slds-button--large slds-button--brand text-bold slds-text-heading--large slds-p-vertical--small"
            onClick={handleGoToRegistration}
          >
            {t('registration-pages:modals.required-event-registration.register-to-participate')}
          </button>
        </div>
      </div>
    </Modal>
  );
};
